import { render, staticRenderFns } from "./AuthMenu.vue?vue&type=template&id=983fd852&scoped=true&"
import script from "./AuthMenu.vue?vue&type=script&lang=js&"
export * from "./AuthMenu.vue?vue&type=script&lang=js&"
import style0 from "./AuthMenu.vue?vue&type=style&index=0&id=983fd852&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983fd852",
  null
  
)

export default component.exports